module.exports = __webpack_public_path__ + "img/Agriculteur_04_FM.58299abe.jpg";